function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.152 6.123l.194 3.284c0 .205.14.322.334.322h1.14c.167 0 .334-.146.334-.322l.194-3.284c0-.205-.139-.381-.333-.381h-1.53c-.194 0-.333.176-.333.381zm2.28 5.248c0-.674-.529-1.231-1.168-1.231-.667 0-1.168.557-1.168 1.231 0 .704.5 1.231 1.168 1.231.64 0 1.168-.527 1.168-1.231zM9.404.816c-.5-.908-1.807-.938-2.308 0L.424 13.042c-.5.909.139 2.082 1.167 2.082H14.91c1.028 0 1.668-1.144 1.167-2.082L9.404.816zM1.73 13.482L8.097 1.813c.083-.117.223-.117.306 0l6.367 11.669c.083.117 0 .235-.14.235H1.87c-.14 0-.223-.118-.14-.235z",
  fill: "#EE921A"
});

var SvgWarningTriangleOutlined = function SvgWarningTriangleOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none"
  }, props), _ref);
};

export default SvgWarningTriangleOutlined;